import { APP_ROUTES } from '@/contants/routes.js';
import { ENV_VARS } from '@/env';
import { useGetQuoteModuleSettings } from '@views/screens/Quote/hooks';
import { Col, Row } from 'antd';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/Buttons/Button';

const isHBUser = ENV_VARS.REACT_APP_THEME === 'halliburton';

const QuotePageHeader = () => {
  const navigate = useNavigate();
  const { data: quoteModuleSettingsData } = useGetQuoteModuleSettings();
  const { isRatingEnabled } = quoteModuleSettingsData || {};

  const handleClickCreate = () => {
    navigate(APP_ROUTES.SEARCH_QUOTE_CREATE, { state: { prevState: true } });
  };

  const handleClickGetRate = () => {
    navigate(APP_ROUTES.SEARCH_QUOTE_GET_RATE, { state: { prevState: true } });
  };

  return (
    <Row justify="space-between" className='py-15 px-14 align="middle'>
      <Col className="flex-1">
        <Row align="right" gutter={25}>
          <Col sm={24}>
            <div className="d-flex justify-content-end gap-1 align-items-end">
              {isRatingEnabled && (
                <Button className={isHBUser ? 'hb-button' : ''} onClick={handleClickGetRate}>
                  {t('translation:quote.buttons.getQuoteRate')}
                </Button>
              )}
              <Button className={isHBUser ? 'hb-button' : ''} onClick={handleClickCreate}>
                {t('translation:quote.buttons.createNewQuote')}
              </Button>
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
export default QuotePageHeader;
